import { useParams } from 'react-router-dom';
import IClinicRepository from '../../2_domain/clinic/iClinicRepository';
import { Notice } from '../../2_domain/notice/notice';
import wrapPromise from '../../lib/asyncBounrdary/wrapPromise';
import Get from '../../lib/di/get';

const useNoticeDetailPageController = () => {
  const clinicRepo = Get.find<IClinicRepository>('IClinicRepository');
  const { noticeId } = useParams();
  const notice = wrapPromise<Id, Notice>(
    clinicRepo.getClinicNoticeById,
    noticeId as any,
    'clinicRepoKey'
  )();

  return {
    notice,
  };
};

export default useNoticeDetailPageController;
